export enum MESSAGE_TITLE {
    ERROR = 'Error',
    ERROR_OCCURED = 'Error Occured',
    SUCCESS = 'Success',
}
